import { render, staticRenderFns } from "./CompletedVacancySummary.vue?vue&type=template&id=4d2ae6db"
import script from "./CompletedVacancySummary.vue?vue&type=script&lang=js"
export * from "./CompletedVacancySummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports